import styled, { css } from 'styled-components'
import { COLOURS } from 'resources'
import { BREAKPOINTS } from 'resources/constants'
import { ReactComponent as InstagramLogo } from 'resources/images/instagram.svg'
import { ReactComponent as FacebookLogo } from 'resources/images/facebook.svg'
import { ReactComponent as LinkedInLogo } from 'resources/images/linkedIn.svg'
import { ReactComponent as TwitterLogo } from 'resources/images/twitter.svg'

export const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SocialLinkButton = styled.a`
  padding: 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${BREAKPOINTS.md}) {
    padding: 10px 15px;
  }

  path {
    transition: fill 0.3s;
    fill: ${COLOURS.white};
  }
  :hover path {
    fill: ${COLOURS.primaryYellow};
  }
`

const baseIconStyles = css`
  width: 14px;
  height: 14px;
  @media (min-width: ${BREAKPOINTS.lg}) {
    width: 20px;
    height: 20px;
  }
`

export const InstagramIcon = styled(InstagramLogo)`
  ${baseIconStyles}
`
export const FacebookIcon = styled(FacebookLogo)`
  ${baseIconStyles}
`
export const TwitterIcon = styled(TwitterLogo)`
  ${baseIconStyles}
`
export const LinkedInIcon = styled(LinkedInLogo)`
  ${baseIconStyles}
`
